import * as React from 'react';
import { Flex, FlexProps } from '@leagueplatform/genesis-commons';
import { Box, GDSStyleObject } from '@leagueplatform/genesis-core';
import { CONTENT_MAX_WIDTH } from './wrappers.constants';

interface MainPageContainerProps extends FlexProps {
  children: React.ReactNode;
}

// @deprecated use PageContainer instead
export const MainPageContainer = ({
  children,
  ...props
}: MainPageContainerProps) => (
  <Flex
    maxWidth={`var(--content-max-width, ${CONTENT_MAX_WIDTH})`}
    marginX="auto"
    padding={{ _: 'oneAndHalf', phone: 'two' }}
    flexDirection="column"
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    {children}
  </Flex>
);

export const PageContainer = ({
  children,
  className,
  css,
}: {
  children: React.ReactNode;
  className?: string;
  css?: GDSStyleObject;
}) => (
  <Box
    className={className}
    css={{
      maxWidth: `var(--content-max-width, ${CONTENT_MAX_WIDTH})`,
      marginX: 'auto',
      paddingInline: '$oneAndHalf',
      '@mobile': {
        paddingInline: '$two',
      },
      ...css,
    }}
  >
    {children}
  </Box>
);
